import { Frequency } from "@sportal/api";

export const LANGUAGE_COOKIE_KEY = "sb-nom_pi_lang";

export const DEFAULT_FREQUENCY = Frequency.Never;
export const DEFAULT_TIME_ZONE = "Etc/GMT";
export const FALLBACK_LANGUAGE = "us_EG";
